<template>
    <a :href="siteUrl" class="m-1 badge" :class="badge" target="_blank">{{siteName}}</a>
</template>

<style scoped lang="scss">
.badge {
    &:hover {
        opacity: .8;
    }
}
</style>

<script>
import novelSites from "../novelSites";
export default {
    props: {
        url: {
            required: true
        },
        domain: {
            default: null,
        },
    },
    data() {
        return {
            sites: novelSites
        }
    },
    methods: {
        getSite() {
            let domain = this.getDomain();
            if (domain && this.sites[domain]) {
                return this.sites[domain];
            }
            return null;
        },
        getDomain() {
            if (this.domain) {
                return this.domain;
            }
            if (this.url) {
                let match = this.url.match(/https?:\/\/([^\/]+)\//);
                if (match) {
                    return match[1];
                }
            }
            return null;
        }
    },
    computed: {
        badge() {
            let site = this.getSite();
            if (site) {
                return {["badge-" + site.badge]: true};
            }
            return {"badge-dark": true};
        },
        siteName() {
            let site = this.getSite();
            if (site) {
                return site.name;
            }
            return this.getDomain();
        },
        siteUrl() {
            return '/jump?url=' + encodeURI(this.url);
        },
    },
}
</script>